import easydropdown from 'easydropdown';

export default {
	init() {

		// janky fix for the global nav logo flashing on load on the homepage
		const docBody = document.body;

		if (docBody.classList.contains('home')) {
			const headerLogo = document.getElementById('header-logo-img');
			const headerLogoImg = headerLogo.dataset.src;
			const headerLogoWhite = document.getElementById('header-logo-img-white');
			const headerLogoWhiteImg = headerLogoWhite.dataset.src;

			headerLogo.setAttribute('src', headerLogoImg);
			headerLogoWhite.setAttribute('src', headerLogoWhiteImg);
		}
		else {
			const headerLogoGlobal = document.getElementById('header-logo-img-global');
			const headerLogoGlobalImg = headerLogoGlobal.dataset.src;

			headerLogoGlobal.setAttribute('src', headerLogoGlobalImg);
		}

		/* HAMBURGER MENU */
		const hamburger_menu_button = document.getElementsByClassName(
			'hamburger'
		);

		const menuToggle = (element) => {
			element.classList.toggle('active');
			document
				.getElementsByClassName('topnav')[0]
				.classList.toggle('show');
			document
				.getElementsByTagName('body')[0]
				.classList.toggle('no-scroll');
		}

		hamburger_menu_button[0].addEventListener('click', function () {
			menuToggle(this);
		});

		/* TOPNAV ACCESSIBILITY */
		const nav_menu_items = document.querySelectorAll('.topnav > ul > li');
		const submenus = document.querySelectorAll('.sub-menu');
		submenus.forEach(submenu => {
			const newButton = document.createElement('button');
			newButton.classList.add('submenu-button');
			newButton.innerText = '⬇';
			submenu.parentElement.appendChild(newButton);
			submenu.parentElement.appendChild(submenu);
		})

		const toggleSubmenu = (item) => {
			const submenu_button = item.querySelector('.submenu-button');
			const submenu = item.querySelector('.sub-menu');

			if (submenu.classList.contains('show')) {
				submenu_button.setAttribute('aria-expanded', false);
				submenu_button.classList.remove('active');
				submenu.setAttribute('aria-hidden', true);
				submenu.classList.remove('show');
			} else {
				submenu_button.setAttribute('aria-expanded', true);
				submenu_button.classList.add('active');
				submenu.setAttribute('aria-hidden', false);
				submenu.classList.add('show');
			}

		}

		nav_menu_items.forEach(item => {
			const submenu_button = item.querySelector('.submenu-button');
			if (submenu_button) {
				submenu_button.addEventListener('click', (e) => {
					e.preventDefault();
					console.log('clicky!');
					toggleSubmenu(item);
				})
			}
		})


		function handleNavigation(e) {
			console.log(e.target);
			// Check if the current URL is the homepage
			if (document.body.classList.contains('home')) {
				menuToggle(hamburger_menu_button[0]);
			}
		}

		// Add click event listener to the anchor links
		const anchorLinks = document.querySelectorAll('.topnav a[href*="#sticky"]');
		console.log('anchorLinks', anchorLinks);
		if (document.body.classList.contains('home')) {
			anchorLinks.forEach(function (link) {
				link.addEventListener("click", (e) => handleNavigation(e));
			});
		}

		// for (let i = 0; i < nav_menu_items.length; i++) {
		//     const submenu_button = nav_menu_items[i].querySelector(
		//         '.submenu-button'
		//     );
		//     const submenu = nav_menu_items[i].querySelector('.sub-menu');
		//     nav_menu_items[i].addEventListener('mouseenter', function () {
		//         if (window.innerWidth > 1024) {
		//             if (submenu_button !== null) {
		//                 submenu_button.setAttribute('aria-expanded', true);
		//                 submenu_button.classList.add('active');
		//             }
		//             if (submenu !== null) {
		//                 submenu.setAttribute('aria-hidden', false);
		//             }
		//         }
		//     });

		//     nav_menu_items[i].addEventListener('mouseleave', function () {
		//         if (window.innerWidth > 1024) {
		//             if (submenu_button !== null) {
		//                 submenu_button.setAttribute('aria-expanded', false);
		//                 submenu_button.classList.remove('active');
		//             }
		//             if (submenu !== null) {
		//                 submenu.setAttribute('aria-hidden', true);
		//             }
		//         }
		//     });
		// }

		const nav_menu_links = document.querySelectorAll(
			'.topnav > ul > li > a, .topnav > ul > li > .submenu-button'
		);
		// if (nav_menu_links !== null) {
		//     for (
		//         let nml_index = 0;
		//         nml_index < nav_menu_links.length;
		//         nml_index++
		//     ) {
		//         nav_menu_links[nml_index].addEventListener(
		//             'focus',
		//             function () {
		//                 this.parentElement.classList.add('focus');
		//             }
		//         );

		//         nav_menu_links[nml_index].addEventListener('blur', function () {
		//             const link_parent = this.parentElement;
		//             setTimeout(function () {
		//                 const target = document.activeElement;
		//                 const target_parent = target.parentElement;
		//                 if (
		//                     !target_parent.parentElement.classList.contains(
		//                         'sub-menu'
		//                     ) &&
		//                     link_parent !== target_parent
		//                 ) {
		//                     link_parent.classList.remove('focus');
		//                 }
		//             }, 100);
		//         });
		//     }
		// }

		const submenu_buttons = document.querySelectorAll(
			'.topnav > ul > li > .submenu-button'
		);
		// if (submenu_buttons !== null) {
		//     for (
		//         let sb_index = 0;
		//         sb_index < submenu_buttons.length;
		//         sb_index++
		//     ) {
		//         submenu_buttons[sb_index].addEventListener(
		//             'click',
		//             function () {
		//                 this.classList.toggle('active');
		//                 let submenu = this.parentElement.querySelector(
		//                     '.sub-menu'
		//                 );
		//                 if (this.classList.contains('active')) {
		//                     this.setAttribute('aria-expanded', true);
		//                     submenu.classList.add('show');
		//                     submenu.setAttribute('aria-hidden', false);
		//                 } else {
		//                     this.setAttribute('aria-expanded', false);
		//                     submenu.classList.remove('show');
		//                     submenu.setAttribute('aria-hidden', true);
		//                 }
		//             }
		//         );
		//     }
		// }

		const submenu_links = document.querySelectorAll(
			'.topnav > ul > li > .sub-menu > li > a'
		);
		// if (submenu_links !== null) {
		//     for (
		//         let sbl_index = 0;
		//         sbl_index < submenu_links.length;
		//         sbl_index++
		//     ) {
		//         if (submenu_links[sbl_index].dataset.text === undefined) {
		//             submenu_links[sbl_index].dataset.text =
		//                 submenu_links[sbl_index].innerHTML;
		//         }
		//         submenu_links[sbl_index].addEventListener('blur', function () {
		//             const link_parent = this.parentElement.parentElement;
		//             setTimeout(function () {
		//                 let target = document.activeElement;
		//                 let target_parent = target.parentElement.parentElement;
		//                 if (link_parent !== target_parent) {
		//                     link_parent.classList.remove('show');
		//                     link_parent.setAttribute('aria-hidden', true);
		//                     link_parent.parentElement
		//                         .querySelector('.submenu-button')
		//                         .classList.remove('active');
		//                     link_parent.parentElement
		//                         .querySelector('.submenu-button')
		//                         .setAttribute('aria-expanded', false);
		//                     link_parent.parentElement.classList.remove('focus');
		//                 }
		//             }, 100);
		//         });
		//     }
		// }

		const submenu_items = document.querySelectorAll(
			'.topnav .menu-item-has-children'
		);
		// if (submenu_items !== null) {
		//     for (
		//         let si_index = 0;
		//         si_index < submenu_items.length;
		//         si_index++
		//     ) {
		//         submenu_items[si_index].addEventListener('click', function (e) {
		//             if (e.target.tagName === 'LI') {
		//                 const submenu_button = this.querySelector(
		//                     '.submenu-button'
		//                 );
		//                 submenu_button.classList.toggle('active');
		//                 let submenu = submenu_button.parentElement.querySelector(
		//                     '.sub-menu'
		//                 );
		//                 if (submenu === null) {
		//                     submenu = submenu_button.parentElement.parentElement.querySelector(
		//                         '.sub-menu'
		//                     );
		//                 }
		//                 if (submenu_button.classList.contains('active')) {
		//                     submenu_button.setAttribute('aria-expanded', true);
		//                     submenu.classList.add('show');
		//                     submenu.setAttribute('aria-hidden', false);
		//                 } else {
		//                     submenu_button.setAttribute('aria-expanded', false);
		//                     submenu.classList.remove('show');
		//                     submenu.setAttribute('aria-hidden', true);
		//                 }
		//             }
		//         });
		//     }
		// }

		/* ALERT BAR */
		const alert_bars = document.querySelectorAll('.alert-bar');
		if (alert_bars !== null) {
			for (let ab_index = 0; ab_index < alert_bars.length; ab_index++) {
				alert_bars[ab_index]
					.querySelector('.close')
					.addEventListener('click', function () {
						alert_bars[ab_index].classList.add('hidden');
						alert_bars[ab_index].setAttribute('aria-hidden', true);
						this.setAttribute('aria-expanded', false);
					});
			}
		}

		/* SKIP LINKS */
		// skip link scroll to section
		const skipToAnchor = aid => {
			var aTag = $(aid);
			var focus = true;
			$('html,body').animate(
				{
					scrollTop: aTag.offset().top,
				},
				'slow'
			);
			var first_child = $(aTag.children()[0]);
			var tag = first_child.prop('tagName').toLowerCase();

			if (
				tag !== 'a' &&
				tag !== 'button' &&
				tag !== 'input' &&
				tag !== 'textarea'
			) {
				if (first_child.attr('tabIndex') !== undefined) {
					first_child.attr('tabIndex', -1).focus();
					first_child.removeAttr('tabIndex');
				} else {
					first_child.focus();
				}
			} else {
				first_child.focus();
			}
		};

		// create skip links
		const skipLinks = () => {
			$('section').each(function () {
				const id = $(this).attr('id');
				if (id !== undefined) {
					// Use the section id to create a label for the items in the skip link list
					var sectionNameArray = id.split('-');
					var sectionName = '';
					for (var i = 0; i < sectionNameArray.length; i++) {
						var str = sectionNameArray[i];
						str = str
							.toLowerCase()
							.replace(/\b[a-z]/g, function (letter) {
								return letter.toUpperCase();
							});
						sectionName += str;
						if (i < sectionNameArray.length - 1) {
							sectionName += ' ';
						}
					}
					var skiplink =
						"<li><a href='#" +
						id +
						"' class='text-link'>Skip to " +
						sectionName +
						'</a></li>';
					$('.skiplinks ul').append(skiplink);
				}
			});

			const skipLinkContainer = $('.skiplinks'),
				skipLink = $('.skiplinks a');

			skipLink.on('focus', function () {
				skipLinkContainer.addClass('show');
			});

			skipLink.on('blur', function () {
				skipLinkContainer.removeClass('show');
			});

			skipLink.on('click', function (e) {
				e.preventDefault();
				skipToAnchor($(this).attr('href'));
			});
		};

		skipLinks();

		/* LINKS/BUTTONS KEYBOARD FOCUS */
		let buttons = document.querySelectorAll(
			'a, button, input[type="submit"], .swiper-button-prev,' +
			' .swiper-button-next'
		);
		if (buttons !== null) {
			for (
				let buttons_index = 0;
				buttons_index < buttons.length;
				buttons_index++
			) {
				const button = buttons[buttons_index];
				button.addEventListener('keyup', function (e) {
					if (e.keyCode === 9) {
						button.classList.add('focus');
					}
				});

				button.addEventListener('blur', function () {
					button.classList.remove('focus');
				});
			}
		}

		/* LAZY LOAD IMAGES */
		let lazy_load_image = document.querySelectorAll('[data-src]');
		if (lazy_load_image !== null) {
			for (
				let lazy_index = 0;
				lazy_index < lazy_load_image.length;
				lazy_index++
			) {
				let img = lazy_load_image[lazy_index];
				let imgWaypoint = new Waypoint({
					element: img,
					handler: function () {
						if (img.getAttribute('src') === '') {
							let src = img.getAttribute('data-src');
							img.setAttribute('src', src);
						}
					},
					offset: '200%',
				});
			}
		}

		/* EASYDROPDOWN SETUP */
		const dropdowns = document.querySelectorAll('select');
		if (dropdowns !== null) {
			for (
				let dropdowns_index = 0;
				dropdowns_index < dropdowns.length;
				dropdowns_index++
			) {
				const dropdown = easydropdown(dropdowns[dropdowns_index], {
					behavior: {
						useNativeUiOnMobile: false,
					},
				});
			}
		}

		/* GRAVITYFORMS UPLOAD FILE BUTTON */
		const upload_buttons = document.querySelectorAll(
			'.gform_wrapper .upload-button'
		);
		if (upload_buttons !== null) {
			for (
				let ub_index = 0;
				ub_index < upload_buttons.length;
				ub_index++
			) {
				const upload_button = upload_buttons[ub_index];
				const upload_input = upload_button.parentElement.querySelector(
					'input[type="file"]'
				);
				const file_name_text = upload_button.parentElement.querySelector(
					'.file-name'
				);
				upload_button.addEventListener('click', function (e) {
					e.preventDefault();
					upload_input.click();
				});
				upload_input.addEventListener('change', function (e) {
					let file_name = '';
					if (this.files && this.files.length > 1) {
						file_name = (
							this.getAttribute('data-multiple-caption') || ''
						).replace('{count}', this.files.length);
					} else if (e.target.value) {
						file_name = e.target.value.split('\\').pop();
					}
					if (file_name) {
						if (file_name.length > 25) {
							file_name = file_name.substr(0, 22) + '...';
						}
						file_name_text.innerHTML = file_name;
					} else {
						file_name_text.innerHTML = 'Choose File...';
					}
				});
			}
		}

		/* BUTTON CTA DATA TEXT FALLBACK */
		let button_ctas = document.querySelectorAll('.button');
		if (button_ctas !== null) {
			for (let bc_index = 0; bc_index < button_ctas.length; bc_index++) {
				const cta = button_ctas[bc_index];
				if (cta.dataset.text === undefined) {
					cta.dataset.text = cta.innerHTML;
				}
			}
		}

		// * * * * * * * * * * * * * * * //
		// PROJECT-SPECIFIC JS //
		// * * * * * * * * * * * * * * * //

	},

	finalize() {
		// JavaScript to be fired on all pages, after page specific JS is fired
	},
};
